module.exports = __webpack_public_path__ + "img/icon-t4.dbcb3cd4.png";